import React from 'react';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { t } from '../../../modules/infra/i18n';
import CheckboxSwitch from '../../common/checkboxSwitch';
import { RoleAllowAdmin } from '../../auth/roleAware';

const BookingSettings = () => {
  const dispatch = useDispatch();

  const onBookNoPayChange = (event, newValue) => {
    dispatch(change('editShop', 'bookNoPay', newValue));
    if (newValue) {
      dispatch(change('editShop', 'allowBookAndReserve', !newValue));
    }
  };

  const onAllowBookAndReserveChange = (event, newValue) => {
    dispatch(change('editShop', 'allowBookAndReserve', newValue));
    if (newValue) {
      dispatch(change('editShop', 'bookNoPay', !newValue));
    }
  };

  return (
    <RoleAllowAdmin>
      <CheckboxSwitch
        name="bookNoPay"
        id="bookNoPay"
        label={t('admin:shop_form.options.allow_booking_without_payment')}
        wrapperClass="layout__item"
        onChange={onBookNoPayChange}
      />
      <CheckboxSwitch
        name="allowBookAndReserve"
        id="allowBookAndReserve"
        label={t('admin:shop_form.options.book_and_provide_card')}
        wrapperClass="layout__item"
        onChange={onAllowBookAndReserveChange}
      />
    </RoleAllowAdmin>
  );
};

export default BookingSettings;
